import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../../auth/services/auth.service";
import {HeaderService} from "../../../tandem-core/services/header.service";
import {SpendingPlan} from "../../models/spending-plan";
import {SpendingPlanService} from "../../services/spending-plan.service";
import {TandemUser} from "../../../auth/models/tandem-user";
import {Timestamp} from "firebase/firestore";
import {CashFlow} from "../../../cash-flows/models/cash-flow";
import {DateService} from "../../../tandem-core/services/date.service";
import {Subject, takeUntil} from "rxjs";

@Component({
  selector: 'tandem-edit-spending-plan',
  templateUrl: './edit-spending-plan.component.html',
  styleUrls: ['./edit-spending-plan.component.scss']
})
export class EditSpendingPlanComponent implements OnInit, OnDestroy {

  userId: string | undefined;
  spendingPlanId: string | null = null;
  spendingPlan: SpendingPlan | undefined;
  user: TandemUser | null = null;

  constructor(private route: ActivatedRoute,
              private auth: AuthService,
              private spendingPlanService: SpendingPlanService,
              private headerService: HeaderService,
              private router: Router,
              private dateService: DateService) {
    this.spendingPlanId = this.route.snapshot.paramMap.get('id');
  }
  private destroy$ = new Subject<void>();
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.auth.$user.pipe(takeUntil(this.destroy$)).subscribe(user => {
      this.userId = user?.id;
      this.user = user;
      if (user && this.spendingPlanId) {
        this.spendingPlanService.get(this.spendingPlanId).subscribe(cf => {
          this.spendingPlan = cf;
          this.headerService.setConfig({
            title: `Edit ${this.spendingPlanService.getTrackingToolName('single', this.user)}`,
            subtitle: this.spendingPlanService.getTrackingToolDescription(user),
            breadcrumbs: [
              {
                label: `${this.spendingPlanService.getTrackingToolName('plural', this.user)}`,
                route: 'spending-plans'
              },
              {
                label: `${this.getTitle(this.spendingPlan).replace(`${this.spendingPlanService.getTrackingToolName('single', user)} from `, '').replaceAll('/', '-')}`,
                route: `spending-plans/${this.spendingPlanId}`
              },
              {label: 'Edit'}
            ]
          });
        })
      }
    });
  }

  private getTitle(t: CashFlow) {
    return `${this.formatDate(this.dateService.getAdjustedTimestampFromDate(t.startDate.toDate()).toDate())} to ${this.formatDate(this.dateService.getAdjustedTimestampFromDate(t.endDate.toDate()).toDate())}`
  }

  formatDate(date: Date) {
    let day: string | number = date.getDate();
    let month: string | number = date.getMonth() + 1; // January is 0!
    let year = date.getFullYear();

    // ensure double digits
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;

    return month + '/' + day + '/' + year;
  }

  onEdit(fp: SpendingPlan) {
    fp.dateModified = Timestamp.now()
    this.spendingPlanService.update(fp).then(res => {
      this.router.navigate(['spending-plans']);
    })
  }
}
